import base from './base.repository';

export default {
    finishRound: (payload) => base.post('rounds/finish-round', payload),
    get: (params) => base.get('rounds', params),
    getAssignations: (userId) => base.get('rounds/round-assignations', { user: userId }),
    getChecklistAnswers: () => base.get('rounds/checklist-answers'),
    startRound: (payload) => base.post('rounds/start-round', payload),
    saveAnnotation: (annotation) => base.post('rounds/annotations', annotation),
    getLastestRounds: userId => base.get(`users/${userId}/latest-rounds`)
}